import { IconType, VtxColumnProps } from '@vertexinc/vtx-ui-react-component-library';
import { TableSettings } from '../..';
import { BulkAction } from '../BulkActions/BulkActionsProps.interface';
import {
  BulkActionsInfo,
  ExpanderIcons,
  FilterModelApi,
  GridDataNativeType,
  GridDataSummaryCollection,
  GridFilter,
  GridSort,
  SortModelApi,
} from './Interfaces';

export enum ShowTableColumnsEnum {
  ALL = 'all',
  FAVORITE = 'favorite',
}

// eslint-disable-next-line @typescript-eslint/ban-types
interface GenericGridProps<T extends object> {
  id: string, // Unique Id of the Grid
  dataTypeDescription: string, // Description of the Data loaded into the Grid. e.g. Customers or Certificates
  showLoadingMessage?: boolean; // Show the Vertex Loading message on the initial load. defaults to true
  model: 'server' | 'client' | 'static'; // Server: Filter & Sort done by Server, Client & Static: Filter & Sort done by Client, Static: No Row API
  expandedRowRender?: (row: T) => JSX.Element; // Callback to Render the Expander Row
  rowExpandable?: (row: T) => boolean; // Callback indicating if Row can be expanded
  getDefaultColumns: () => VtxColumnProps<T>[]; // Callback to get the Default Columns from the Grid
  rowParser: (row: GridDataNativeType) => T; // Callback to parse each Row. Parse each row from the Native Data Type to the GridRowData Type
  // eslint-disable-next-line max-len
  apiGetRowsServerModel?: (startRow:number, endRow:number, filterModel: FilterModelApi, sortModel: SortModelApi) => Promise<GridDataSummaryCollection>; // Callback API used for Client Model
  apiGetRowsClientModel?: () => Promise<GridDataSummaryCollection>; // Callback API used for Client Model
  // eslint-disable-next-line max-len
  verticalHeightOffset?: number; // Vertical height in pixels of the page not occupied by table. The Vertical Height of Rows section will be calculated as: 'calc(vh - verticalHeightOffset px)'
  initialPageSize?: number; // The Initial Page Size, defaults to 25
  virtualPageSize?: number; // The Virtual Page Size, default to 100
  pageSizeOptions?: string[]; // The Options for the Page Sizes, defaults to ['25', '50', '100']
  useCache?: boolean; // Use the Data Cache, defaults to true
  hidePagingOnSinglePage?: boolean; // Hide the Paging options for a single page, default to true
  getRowKey?: (row: T) => string; // Optional.  If data does not contain 'key' value this must be specified to return unique key for row
  expanderIcons?: ExpanderIcons; // Expander Icons used
  expandRowByClick?: boolean; // Expand Row by clicking anywhere in the row, defaults to false
  dataRows?: GridDataNativeType[]; // Static Supplied Data Rows.  Use Static Model.  No API will be called
  autoRefreshSeconds?: number; // Auto Refresh Interval, defaults to disabled.
  horizontalWidth?: 'max-content' | 'max-width'; // Horizontal Width.  Defaults to 'max-content' (scale to fit data). 'max-width' scale to container
  showTableManagement?: boolean; // Show the Table Management button, defaults to false
  showAllFavoriteColumns?: boolean; // Show the All / Favorites button, defaults to false
  showClearFilters?:boolean; // Show the Clear Filters button, defaults to false
  showClearSorters?:boolean; // Show the Clear Sorters button, defaults to false
  additionalTableSettings?: TableSettings; // Additional Table Settings. Uses to provide additional column properties.  Used by Table management
  onFilterSortingChange?: (filters: GridFilter[], sorters: GridSort[]) => void; // Filtering or Sorting in the Grid has Changed
  externalFilter?: GridFilter; // Optional. External filter that controls Grid Column.  When it changes the internal grid Filter will be updated.
  refreshKey?: string; // Optional. if the Refresh Key changes the Grid will Refresh
  alwaysHiddenFilterBreadcrumbs?: string[]; // Array of columns that will not show up in Filter Breadcrumbs
  alwaysHiddenSorterBreadcrumbs?: string[]; // Array of columns that will not show up in Sorting Breadcrumbs
  bulkActions?: BulkActionsInfo; // Bulk Actions.  If specified, Bulk Actions button will be shown the Rows will be selectable
  selectionType?: 'single' | 'multiple'; // Row Selection type, defaults to 'multiple'
  showLoadingIndicator?: boolean; // Show the Loading Indicator
  onSelectedRowsChange?: (rowKeysSelected: React.Key[], rowsSelected: T[]) => void; // Optional callback if Selected Rows has Changed
}

export default GenericGridProps;
